import { Inline, Text, IconChevron, Box, TextLink } from 'braid-design-system';
import React from 'react';

type BreadCrumb = {
  url: string;
  text: string;
};

type Props = {
  items: BreadCrumb[];
};

const Breadcrumbs = ({ items }: Props) => (
  <Box marginY="gutter">
    <Inline space="small" alignY="center">
      {items
        .filter(({ text }) => text)
        .map(({ url, text }) => (
          <Text key={url} size="standard">
            <Box component="span" marginRight="xsmall">
              <IconChevron direction="left" />
            </Box>
            <TextLink href={url}>{text}</TextLink>
          </Text>
        ))}
    </Inline>
  </Box>
);

export { Breadcrumbs };
